import { HttpInterceptorFn } from '@angular/common/http';

import { AuthConstants } from '../../auth/constants/auth.constants';
import { environment } from '../../../environments/environment';

/**
 * Attaches the stored access token as a Bearer Authorization header to every
 * request made to our own API, so callers don't need to add it themselves.
 */
export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem(AuthConstants.TOKEN_KEY);

  if (!token || !req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    })
  );
};
